module.exports = __webpack_public_path__ + "img/login-avatar.b8d6e7e3.png";